import { getAddressComponents } from "./utils/getAddressComponents.js";
import { formatAddress__ } from "./utils/formatAddress__.js";
import { validateAddress__ } from "./utils/validateAddress__.js";
const getAddressInfo = (result) => {
  const addr = getAddressComponents(result), {
    address1,
    route,
    streetNumber,
    city,
    formattedPostalCode,
    state,
    latitude,
    longitude,
    placeId
  } = addr, { formattedAddress, cityReplacement } = formatAddress__(addr), validationInfo = validateAddress__(addr), fullAddress = {
    formattedAddress,
    cityReplacement,
    route,
    streetNumber,
    streetAddress: address1,
    isValid: validationInfo.isValid,
    city: city ?? (cityReplacement ? "New York" : null),
    state: state ?? null,
    postalCode: formattedPostalCode ?? null,
    latitude,
    longitude,
    googlePlaceId: placeId
  };
  return validationInfo.isValid || (fullAddress.whyNotValid = validationInfo.reason), fullAddress;
};
export {
  getAddressInfo
};
//# sourceMappingURL=getAddressInfo.js.map
